export default "__VITE_ASSET__S4M0WtOw__"